// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

ion-button {
  margin: 0;
  height: 48px;
  width: 100%;
  --border-radius: 5px;
  --box-shadow: none;
  text-transform: none;
  --background-activated-opacity: .9;
  --background-focused-opacity: .9;
  --background-activated: var(--background);
  --background-focused: var(--background);
  --ripple-color: transparent;
}
ion-button.small {
  height: 38px;
}
ion-button.transparent {
  --background: var(--ion-color-transparent);
}
ion-button.primary {
  --background: var(--ion-color-primary);
}
ion-button.secondary {
  --background: var(--ion-color-secondary);
}
ion-button.dark {
  --background: var(--ion-color-white);
  --border-color: var(--ion-color-black);
  --border-style: solid;
  --border-width: 2px;
}
ion-button.white {
  --background: var(--ion-color-white);
}
ion-button.light {
  --background: var(--ion-color-light);
}
ion-button.black {
  --background: var(--ion-color-black);
  --border-color: var(--ion-color-white);
  --border-style: solid;
  --border-width: 1px;
}
ion-button.disabled {
  --background: var(--ion-color-disabled);
}
ion-button.shape-circle {
  --border-radius: 100%;
}
ion-button.green-unactive {
  opacity: 1 !important;
  --background: var(--ion-color-success-green) !important;
  --border-color: var(--ion-color-emerald)!important;
  --border-style: solid;
  --border-width: 1px;
}

.button-disabled {
  --background: var(--ion-color-disabled) !important;
}

ion-button {
  padding: 5px 0;
  --border-radius: 0;
  --padding-top: 0;
  --padding-bottom: 0;
  --padding-start: 0;
  --padding-end: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/button/button/button.component.scss","webpack://./src/app/components/button/button-link/button-link.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;ACCF;;ADEA;EACE,SAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kCAAA;EACA,gCAAA;EACA,yCAAA;EACA,uCAAA;EACA,2BAAA;ACCF;ADCE;EACE,YAAA;ACCJ;ADEE;EACE,0CAAA;ACAJ;ADGE;EACE,sCAAA;ACDJ;ADIE;EACE,wCAAA;ACFJ;ADKE;EACE,oCAAA;EACA,sCAAA;EACA,qBAAA;EACA,mBAAA;ACHJ;ADME;EACE,oCAAA;ACJJ;ADQE;EACE,oCAAA;ACNJ;ADSE;EACE,oCAAA;EACA,sCAAA;EACA,qBAAA;EACA,mBAAA;ACPJ;ADUE;EACE,uCAAA;ACRJ;ADYE;EACE,qBAAA;ACVJ;ADcE;EACE,qBAAA;EACA,uDAAA;EACA,kDAAA;EACA,qBAAA;EACA,mBAAA;ACZJ;;ADgBA;EACE,kDAAA;ACbF;;AA7DA;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAgEJ","sourcesContent":[":host {\n  display: block;\n}\n\nion-button {\n  margin: 0;\n  height: 48px;\n  width: 100%;\n  --border-radius: 5px;\n  --box-shadow: none;\n  text-transform: none;\n  --background-activated-opacity: .9;\n  --background-focused-opacity: .9;\n  --background-activated: var(--background);\n  --background-focused: var(--background);\n  --ripple-color: transparent;\n\n  &.small {\n    height: 38px;\n  }\n\n  &.transparent {\n    --background: var(--ion-color-transparent);\n  }\n\n  &.primary {\n    --background: var(--ion-color-primary);\n  }\n\n  &.secondary {\n    --background: var(--ion-color-secondary);\n  }\n\n  &.dark {\n    --background: var(--ion-color-white);\n    --border-color: var(--ion-color-black);\n    --border-style: solid;\n    --border-width: 2px;\n  }\n\n  &.white {\n    --background: var(--ion-color-white);\n  }\n\n\n  &.light {\n    --background: var(--ion-color-light);\n  }\n\n  &.black {\n    --background: var(--ion-color-black);\n    --border-color: var(--ion-color-white);\n    --border-style: solid;\n    --border-width: 1px;\n  }\n\n  &.disabled {\n    --background: var(--ion-color-disabled);\n  }\n\n  // Shape\n  &.shape-circle {\n    --border-radius: 100%;\n  }\n\n\n  &.green-unactive {\n    opacity: 1 !important;\n    --background: var(--ion-color-success-green) !important;\n    --border-color: var(--ion-color-emerald)!important;\n    --border-style: solid;\n    --border-width: 1px;\n  }\n}\n\n.button-disabled {\n  --background: var(--ion-color-disabled) !important;\n\n}\n","@import \"../button/button.component.scss\";\n\nion-button {\n    padding: 5px 0;\n    --border-radius: 0;\n    --padding-top: 0;\n    --padding-bottom: 0;\n    --padding-start: 0;\n    --padding-end: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
